import { render, staticRenderFns } from "./paySucc.vue?vue&type=template&id=3683820a&scoped=true&"
import script from "./paySucc.vue?vue&type=script&lang=js&"
export * from "./paySucc.vue?vue&type=script&lang=js&"
import style0 from "./paySucc.vue?vue&type=style&index=0&id=3683820a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683820a",
  null
  
)

export default component.exports